module.exports = __webpack_public_path__ + "static/media/Hillrose_logo-white.51e747a3.png";